import { render, staticRenderFns } from "./HeritagePage.vue?vue&type=template&id=0d2ce535&scoped=true"
import script from "./HeritagePage.vue?vue&type=script&lang=js"
export * from "./HeritagePage.vue?vue&type=script&lang=js"
import style0 from "./HeritagePage.vue?vue&type=style&index=0&id=0d2ce535&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d2ce535",
  null
  
)

export default component.exports